module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avaliacao-redacao"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box pa-3"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "title mb-1"
  }, [_vm._v("\n        Tema: "), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v(_vm._s(_vm.tema.titulo))])]), _vm._v("\n      ("), _c('a', {
    attrs: {
      "href": _vm.tema.enunciado,
      "target": "_blank"
    }
  }, [_vm._v("Clique aqui para visualizar o enunciado")]), _vm._v(")\n    ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "box": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.redacao.titulo),
      callback: function($$v) {
        _vm.$set(_vm.redacao, "titulo", $$v)
      },
      expression: "redacao.titulo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3",
    on: {
      "cut": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Texto",
      "box": "",
      "auto-grow": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.redacao.texto),
      callback: function($$v) {
        _vm.$set(_vm.redacao, "texto", $$v)
      },
      expression: "redacao.texto"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n    Nº de caracteres: " + _vm._s(_vm.countCharacters) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "warning"
    }
  }, [_vm._v("\n        - A redação deve possuir no mínimo " + _vm._s(_vm.limitCharacters) + " caracteres para ser finalizada;"), _c('br'), _vm._v("\n        - Ao clicar em salvar, essa redação será salva e poderá ser acessada novamente através do link enviado no e-mail;"), _c('br'), _vm._v("\n        - Ao clicar em finalizar, a redação será enviada e não poderá mais ser acessada.\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "acoes-wrapper"
  }, [_c('div', {
    staticClass: "btn-voltar-wrapper grow"
  }, [_c('v-btn', {
    staticClass: "btn-voltar ma-0",
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.voltar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Voltar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acoes"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": "",
      "disabled": _vm.$v.redacao.$invalid
    },
    on: {
      "click": function($event) {
        _vm.showLoaderOnSave = true;
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-save"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Salvar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": "",
      "disabled": _vm.$v.redacao.$invalid || (_vm.countCharacters < _vm.limitCharacters)
    },
    on: {
      "click": function($event) {
        return _vm.finalizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-gavel"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Finalizar")])])], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-header-content"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Sua redação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d17552b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/avaliacao/components/Redacao.vue
// module id = 578
// module chunks = 2